let postLoginSideBar = [
    {
        menu: {
            label: "My Portfolio",
            linkTo: `/portfolio`,
            class: "myportfolio_navicon",
        },
    },
    {
        "menu": {
            "label": "SIP",
            "linkTo": "/sip/select-fund",
            "class": "invest_navicon_sip",
        }
    },
    {
        "menu": {
            "label": "Lumpsum",
            "linkTo": "/transact/lumpsum-invested-funds",
            "class": "invest_navicon",
        }
    },
    {
        menu: { label: "Other Transactions", linkTo: ``, class: "invest_navicon" },
        subMenu: [
            // {
            //     menu: {
            //         label: "Quick Invest",
            //         linkTo: `/transact/quick-invest`,
            //         class: "xyz",
            //     },
            // },
            // {
            //     menu: {
            //         label: "Lumpsum",
            //         linkTo: `/transact/lumpsum-invested-funds`,
            //         class: "xyz",
            //     },
            // },
            // {
            //     menu: {
            //         label: "Lumpsum - Cashflow",
            //         linkTo: `/transact/lumpsum-cashflow`,
            //         class: "xyz",
            //     },
            // },
            // { menu: { label: "SIP", linkTo: `/transact/sip`, class: "xyz" } },
            { menu: { label: 'FAB Plan', linkTo: `/fab-plan/scheme-selection`, class: "xyz" }, },
            { menu: { label: "Create Folio", linkTo: `/onboarding/personal`, class: "xyz", }, },
        ],
    },
    {
        menu: {
            label: "Scheduled Investments",
            linkTo: ``,
            class: "mnschedule_navicon",
        },
        subMenu: [
            {
                menu: {
                    label: "SIP",
                    linkTo: "/schedule-investments/sip",
                    class: "_ac",
                },
            },
        ],
    },
    {
        menu: { label: "Reports", linkTo: ``, class: "report_navicon" },
        subMenu: [
            {
                menu: {
                    label: "SIP Reports",
                    linkTo: `/reports/sip-report`,
                    class: "_ac",
                },
            },
            {
                menu: {
                    label: "Capital Gain / Loss Statement",
                    linkTo: `/reports/capital-gain-loss`,
                    class: "_ac",
                },
            },
            {
                menu: {
                    label: "Account Statement",
                    linkTo: `/reports/account-statement`,
                    class: "_ac",
                },
            },
        ],
    },
    {
        menu: { label: "Manage Account", linkTo: ``, class: "manageac_navicon" },
        subMenu: [
            {
                menu: {
                    label: "Manage Bank",
                    linkTo: `/manage-account/add-new-bank`,
                    class: "_ac",
                },
            },
            {
                menu: {
                    label: "Add Mandate",
                    linkTo: `/manage-account/add-new-mandate`,
                    class: "_ac",
                },
            },
            {
                menu: {
                    label: "Add E-Mandate",
                    linkTo: `/manage-account/emandate`,
                    class: "_ac",
                },
            },
            {
                menu: {
                    label: "UPI Mandate",
                    linkTo: `/manage-account/upimandate`,
                    class: "_ac",
                },
            },
            {
                menu: {
                    label: "Add Nominee",
                    linkTo: `/manage-account/nomineemanage`,
                    class: "_ac",
                },
            },
        ],
    },
];

export default postLoginSideBar;

